__turbopack_context__.v({
  "companyDetails": "CompanyDetails-module-scss-module__ZQfNda__companyDetails",
  "companyName": "CompanyDetails-module-scss-module__ZQfNda__companyName",
  "item": "CompanyDetails-module-scss-module__ZQfNda__item",
  "key": "CompanyDetails-module-scss-module__ZQfNda__key",
  "value": "CompanyDetails-module-scss-module__ZQfNda__value",
  "visuallyHidden": "CompanyDetails-module-scss-module__ZQfNda__visuallyHidden",
});
